module.exports = __webpack_public_path__ + "media/images/vector-89@2x-e7b83c0e54647c96dfd433839ba5600d.png";